import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { useParams, useHistory } from 'react-router'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { TableOutline } from '../../elements'
import { getEventStatus, systemsInfoTableHeadings } from './constant'
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons'
import { eventService } from '../../Services'
import * as messageTypes from '../../utils/messageTypes'
import StatusButton from '../../Components/StatusButton'
import { DisplayMessage, Loader } from '../../Components'
import CustomDialog from '../../Components/CustomDialog'
import SiteEventViewer from '../Reports/SitesDashboard/SiteEventViewer'

function SystemsInfo(props) {
  const classes = useStyles()
  const [showTable, setShowTable] = useState(true)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(1)
  const [tableData, setTableData] = useState([])
  const [eventViewerOpen, setEventViewerOpen] = useState(false)
  const [siteEventData, setSiteEventData] = useState(null)
  const eventIdRef = useRef(null)

  const { event_id, programs_id } = useParams()
  const history = useHistory()

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const getSystemInEvent = () => {
    setLoading(true)
    eventService.getSystemInEvent(props.accountId, event_id, page - 1, rowsPerPage)
      .then(eventData => {
        setLoading(false)
        setTotalCount(eventData.total_count)
        setSiteTable(eventData.events)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }

  const setSiteTable = (sitesData) => {
    let siteTable = []
    sitesData.map(obj => {
      let tableObj = [
        {
          id: 'systemName',
          className: classes.tableCenter,
          value: _.get(obj, 'system_name', ''),
        },
        {
          id: 'systemId',
          className: classes.tableCenter,
          value: <Box className={classes.link} onClick={() => history.push(`/programs/${programs_id}/systems/${_.get(obj, 'site_id', '-')}`)}>{_.get(obj, 'site_id', '-')}</Box>,
        },
        {
          id: 'scheduledEnergy',
          className: classes.tableCenter,
          value: obj && obj.scheduled_energy_kwh ? obj.scheduled_energy_kwh.toFixed(2) : '-',
        },
        {
          id: 'actualEnergy',
          className: classes.tableCenter,
          value: obj.type === 'battery_charge' ? !_.isNil(obj.total_energy_charged_kwh) ? obj.total_energy_charged_kwh.toFixed(2) : '-' : obj.type === 'battery_discharge' ? !_.isNil(obj.total_energy_discharged_kwh) ? obj.total_energy_discharged_kwh.toFixed(2) : '-' : '-',
        },
        {
          id: 'scheduledPower',
          className: classes.tableCenter,
          value: obj && obj.scheduled_power_kw ? obj.scheduled_power_kw.toFixed(2) : '-',
        },
        {
          id: 'actualPower',
          className: classes.tableCenter,
          value: obj.type === 'battery_charge' ? !_.isNil(obj.avg_power_charged_kw) ? obj.avg_power_charged_kw.toFixed(2) : '-' : obj.type === 'battery_discharge' ? !_.isNil(obj.avg_power_discharged_kw) ? obj.avg_power_discharged_kw.toFixed(2) : '-' : '-',
        },
        {
          id: 'eventStatus',
          value: <StatusButton color={getEventStatus(obj.status).color} text={getEventStatus(obj.status).text} />,
        },
        (props.isSuperAdmin || props.isViewOnly) && {
          id: 'eventInfo',
          className: classes.tableCenter,
          value: (
            <Box
              className={classes.link}
              onClick={() => handleOpenEventInfo(_.get(obj, 'site_id', '-'))}
            >
              View
            </Box>
          ),
        },
      ]
      siteTable.push(tableObj)
    })
    setTableData(siteTable)
  }

  const normalizeToViewerData = (resp) => {
    const rows = Array.isArray(resp?.data) ? resp.data : (resp?.data ? [resp.data] : [])
    return {
      meta: {
        serverTimeStamp: resp?.meta?.serverTimeStamp || new Date().toISOString(),
        rowCount: resp?.meta?.rowCount || rows.length,
      },
      data: rows,
    }
  }

  useEffect(() => {
    if (props?.data?.event_id) {
      eventIdRef.current = props.data.event_id
    } 
  }, [props?.data?.event_id])

  const handleOpenEventInfo = (siteId) => {
    const resolvedEventId = eventIdRef.current
    if (!resolvedEventId || !siteId || siteId === '-') return
    setSiteEventData(null)
    setEventViewerOpen(true)
    eventService.getSiteEventDataBySite(resolvedEventId, siteId, props.accountId)
      .then((siteData) => setSiteEventData(normalizeToViewerData(siteData)))
      .catch((error) => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to load Event Information'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    getSystemInEvent()
  }, [page, rowsPerPage])

  return (
    <Box className={classes.contentWrapper} mt={3.75} id="systems_wrapper">
      <Box display="flex" justifyContent="space-between" className={classes.contentTitle} p={1}>
        <Box>Systems Information</Box>
        {showTable ? <VisibilityOffOutlined className={classes.eyeIcon} onClick={() => setShowTable(showTable => !showTable)} /> : <VisibilityOutlined className={classes.eyeIcon} onClick={() => setShowTable(showTable => !showTable)} />}
      </Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      {showTable && <Box p={2}>
        <TableOutline
          tableHeadings={systemsInfoTableHeadings(classes, props.isSuperAdmin, props.isViewOnly )}
          tableData={tableData}
          totalElement={totalCount}
          pagination={true}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
      }
      <CustomDialog
        open={eventViewerOpen}
        handleClose={() => setEventViewerOpen(false)}
        title="Event Information"
        content={
          <Box className={classes.eventViewerPopupContainer}>
            {siteEventData ? (
              <SiteEventViewer isPopup={true} initialData={siteEventData} />
            ) : (
              <Typography>Loading…</Typography>
            )}
          </Box>
        }
        maxWidth="xl"
        fullWidth
      />
    </Box>
  )
}

const mapStateToProps = ({ auth, programs }) => {
  const { accountId, currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { accountId, currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

export default connect(mapStateToProps, {})(SystemsInfo)